/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for common mobile log service.
 */
'use strict';

angular.module('services.log', []).factory('logFactory', function (AUDIT_DATA_TYPES, $filter, AuditViewFactory) {
  return {
    /**
     * Returns the event type string
     * for the audit event.
     *
     * @param {object} audit - The audit event object.
     * @returns {string} A formatted event string.
     */
    getEventType: function (audit) {
      var data = audit.data,
        dataType = AUDIT_DATA_TYPES[audit.type] || '',
        val;
      switch (dataType) {
        case 'boolean':
          val = data.newValue;
          break;
        case 'string':
          val = data.newValue;
          break;
        case 'date':
          val = moment(data.newValue.end).format('MMMM D, YYYY');
          break;
        case 'serviceaccountchange':
          return AuditViewFactory.getNewServiceAccountUserName(audit);
        case 'function':
          return AuditViewFactory.getAuditViewType(audit.type, data);
        default:
          val = !_.isUndefined(data) && !_.isNull(data) ? $filter('number')(data.newValue) : audit.username;
          break;
      }
      return $filter('i18n')(audit.type, [val]);
    }
  };
});
